import axiosInst from "../../Config";
import { Decrypt_Value } from "../EncryptDecrypt";

const Pat_ID =
  localStorage.getItem("PID") &&
  Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

export const ProviderListApi = async () =>
  await axiosInst.get(`/vozoportal/Providerlist?pid=${Pat_ID}`);

export const MessageListApi = async (credential) =>
  await axiosInst.post(`/vozoportal/patient/getMessagelist`, credential);

export const MessageSendApi = async (credential) =>
  await axiosInst.post(`/vozoportal/patient/sendMessage`, credential);

export const PreviewDownloadApi_1 = async (credential) =>
  await axiosInst.put(`/vozoportal/PreviewDownload`, credential);

export const UnreadCountUpdateApi = async (credential) =>
  await axiosInst.put(`/vozoportal/patient/unreadCountUpdate`, credential);

export const PinchatApi = async (credential) =>
  await axiosInst.put(`/vozoportal/patient/pinchat`, credential);
